import React from 'react';
import ProvidersMedspaPage from '../../../pages/Practitioners';

const MedspaAdminPractitioners = () => <ProvidersMedspaPage />;

export default MedspaAdminPractitioners;
